// Access right types
export const ACCESS_RIGHT_TYPES = {
	VIEW: "VIEW",
	CREATE: "CREATE",
	EDIT: "EDIT",
	DELETE: "DELETE",
	SYNC: "SYNC",
};

// Access right areas - mirror of backend config/constant.js ACCESS_RIGHT_AREAS
export const ACCESS_RIGHT_AREAS = {
	USERS: "USERS",
	ROLES: "ROLES",
	PROJECTS: "PROJECTS",
	COMPANIES: "COMPANIES",
	TEMPLATE: "TEMPLATE",
	PROJECT_PERMISSION_TEMPLATE: "PROJECT_PERMISSION_TEMPLATE",
	CAPMO_IMPORT: "CAPMO_IMPORT",
};

// Right types meaningful per area - mirror of backend AREA_CAPABILITIES;
// drives the read-only role reference matrix.
export const AREA_CAPABILITIES = {
	[ACCESS_RIGHT_AREAS.USERS]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.CREATE,
		ACCESS_RIGHT_TYPES.EDIT,
		ACCESS_RIGHT_TYPES.DELETE,
	],
	[ACCESS_RIGHT_AREAS.ROLES]: [ACCESS_RIGHT_TYPES.VIEW],
	[ACCESS_RIGHT_AREAS.PROJECTS]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.CREATE,
		ACCESS_RIGHT_TYPES.DELETE,
	],
	[ACCESS_RIGHT_AREAS.COMPANIES]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.CREATE,
		ACCESS_RIGHT_TYPES.EDIT,
		ACCESS_RIGHT_TYPES.DELETE,
	],
	[ACCESS_RIGHT_AREAS.TEMPLATE]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.CREATE,
		ACCESS_RIGHT_TYPES.EDIT,
		ACCESS_RIGHT_TYPES.DELETE,
	],
	[ACCESS_RIGHT_AREAS.PROJECT_PERMISSION_TEMPLATE]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.CREATE,
		ACCESS_RIGHT_TYPES.EDIT,
		ACCESS_RIGHT_TYPES.DELETE,
	],
	[ACCESS_RIGHT_AREAS.CAPMO_IMPORT]: [
		ACCESS_RIGHT_TYPES.VIEW,
		ACCESS_RIGHT_TYPES.SYNC,
	],
};

// Helper function to check permissions for object structure - simplified to avoid excessive logging
export const checkPermission = (permissions, area, type) => {
	// If permissions is undefined or null, return false
	if (!permissions) {
		return false;
	}

	// If permissions is empty object or not an object
	if (
		typeof permissions !== "object" ||
		Object.keys(permissions).length === 0
	) {
		return false;
	}

	// Check if area exists in permissions and if the specific type is true
	// Add safer checks to avoid possible undefined values
	return Boolean(permissions[area] && permissions[area][type] === true);
};
